import common from './common'
import res from '@/i18n/en/res'
const en = {
  ...common,
  reservation: res,
}
export default en
